import { Box, VStack, Icon, Heading, Text } from '@chakra-ui/react';
import { FiMonitor } from 'react-icons/fi'

interface DesktopOnlyNoticeProps {
  title?: string
  message: string
  desktopHint?: string
  children?: React.ReactNode
}

export function DesktopOnlyNotice({
  title = 'This tool is coming to mobile', message, desktopHint, children,
}: DesktopOnlyNoticeProps) {
  return (
    <Box px={4} py={12}>
      <VStack gap={4} maxW="md" mx="auto" textAlign="center">
        <Icon boxSize={12} color="accent" asChild><FiMonitor /></Icon>
        <Heading size="md">{title}</Heading>
        <Text color="gray.600">{message}</Text>
        {desktopHint && <Text fontSize="sm" color="gray.500">{desktopHint}</Text>}
        {children && <Box w="full" pt={4}>{children}</Box>}
      </VStack>
    </Box>
  );
}
